import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import socmedia from "../api/socmedia";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  // color: theme.palette.text.secondary,
  height: 100,
}));

export default function RowAndColumnSpacing() {
  return (
    <Box>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {socmedia.map(({ id, platform, invitation, icon, link, brand }) => {
          return (
            <Grid item xs={12} sm={6} md={6} key={id}>
              <Item elevation={0}>
                <Button
                  size="large"
                  variant="contained"
                  startIcon={icon}
                  sx={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    textTransform: "none",
                    bgcolor: brand,
                  }}
                  href={link}
                  rel="noopener"
                  target="_blank"
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: 16,
                      color: "white",
                    }}
                  >
                    {invitation}
                  </Typography>
                </Button>
              </Item>
            </Grid>
          );
        })}

        {/* Resume Button */}
        <Grid item>
          <Item elevation={0}>
            <Button
              size="small"
              variant="contained"
              sx={{
                overflow: "hidden",
                textTransform: "none",
                bgcolor: "linear-gradient(to right, #00c7ff, #00a6ff)",
              }}
              href="https://amirahnasihah.notion.site/Nor-Amirah-Nasihah-Binti-Nazili-0f6b60c36bf94a35a632b0050917dee2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Typography variant="caption">digital resume</Typography>
            </Button>
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
}
